var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.875 19.5625C28.875 21.53 27.28 23.125 25.3125 23.125C23.345 23.125 21.75 21.53 21.75 19.5625C21.75 17.595 23.345 16 25.3125 16C27.28 16 28.875 17.595 28.875 19.5625Z",
    stroke: "#456173",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 30.9137V32.2C17 33.7464 18.2536 35 19.8 35H30.825C32.3714 35 33.625 33.7464 33.625 32.2V31.0459C33.625 29.6995 32.8134 28.4834 31.5368 28.0553C29.7123 27.4433 27.3981 26.6875 25.3125 26.6875C23.27 26.6875 20.5457 27.4124 18.9299 28.0172C17.7321 28.4655 17 29.6348 17 30.9137Z",
    stroke: "#456173",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.49309c278f0fe324656bebf62cb2a528.svg";
export { ForwardRef as ReactComponent };